import { createUseStyles } from 'react-jss'

import config from 'styles/config'
import { textSize, color, titleFont, titleFontSemiBold, backgroundColor, zIndex } from '@portal/kit/pkg/styles'

const mainNavStyles = createUseStyles(theme => ({
  mainNavContainer: {
    minHeight: 31
  },
  mainNav: {
    display: 'block',
    margin: '-7px -10px 0 -10px',
    position: 'relative',
    textAlign: 'center',
    userSelect: 'none',
    overflow: 'hidden',
    ...backgroundColor('mainBackground')
  },
  mainNavIsFixed: {
    position: 'fixed',
    ...zIndex('fixedNav'),
    top: 0,
    left: 0,
    right: 0,
    margin: 0,
    boxShadow: config.colors.headerShadow
  },
  // is receiving navItems to check wether size is bigger than viewport or not
  mainNavWrap: {
    display: 'flex',
    whiteSpace: 'nowrap',
    textAlign: 'center'
  },
  navItem: {
    flexGrow: 1,
    display: 'inline-block',
    position: 'relative',
    padding: 7,
    borderBottom: '2px solid transparent',
    whiteSpace: 'nowrap',
    ...textSize(14, 22),
    ...color('textDefault'),
    ...titleFont()
  },
  navItemOn: {
    pointerEvents: 'none',
    color: theme.main_color,
    whiteSpace: 'nowrap',
    ...textSize(14, 22),
    ...backgroundColor('mainBackground'),
    ...titleFontSemiBold(),

    '&:after': {
      content: '" "',
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: -2,
      backgroundColor: theme.main_color,
      height: 2,
      borderRadius: '2px 2px 0 0',
    }
  },
  mainNavWithOverflow: {
    padding: '0 10px',
    overflowScrolling: 'touch',
    overflowX: 'scroll',
    textAlign: 'left',
    '&::-webkit-scrollbar': {
      height: '0 !important'
    },
    scrollbarWidth: 'none', // firefox
    '-ms-overflow-style': 'none'
  },
  mainNavContainerWithOverflow: {
    '&:after': {
      position: 'absolute',
      content: '" "',
      right: -10,
      top: 0,
      bottom: 0,
      width: 36,
      background: 'gradient(linear, left top, right top, color-stop(0%, rgba(255, 255, 255, 0)), color-stop(100%, rgba(255, 255, 255, 1)))',
      pointerEvents: 'none'
    }
  },
  [config.mediaQueries.tabletPortrait]: {
    mainNavWithOverflow: {
      padding: 0
    }
  }
}))

export default mainNavStyles
